import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-156b2c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "logo-img" }, null, -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-title" }, "桂满陇授权管理系统", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "首页", -1 /* HOISTED */))
const _hoisted_4 = { class: "navbar-dropdown-menu" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-bold" }, "数据", -1 /* HOISTED */))
const _hoisted_6 = { class: "navbar-dropdown-menu" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-bold" }, "管理", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "用户管理", -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资源监控", -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务状态", -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "配置", -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "日志", -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "API", -1 /* HOISTED */))
const _hoisted_14 = { class: "navbar-dropdown-menu" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-bold" }, "账号", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设置", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "密码", -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退出", -1 /* HOISTED */))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "登录", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_navbar_brand = _resolveComponent("b-navbar-brand")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_navbar_toggle = _resolveComponent("b-navbar-toggle")!
  const _component_b_nav_item = _resolveComponent("b-nav-item")!
  const _component_entities_menu = _resolveComponent("entities-menu")!
  const _component_b_nav_item_dropdown = _resolveComponent("b-nav-item-dropdown")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_navbar_nav = _resolveComponent("b-navbar-nav")!
  const _component_b_collapse = _resolveComponent("b-collapse")!
  const _component_b_navbar = _resolveComponent("b-navbar")!

  return (_openBlock(), _createBlock(_component_b_navbar, {
    "data-cy": "navbar",
    toggleable: "md",
    type: "dark",
    class: "jh-navbar"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_b_navbar_brand, {
        class: "logo",
        "b-link": "",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ], undefined, true),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_b_navbar_toggle, {
        right: "",
        class: "jh-navbar-toggler d-lg-none",
        href: "javascript:void(0);",
        "data-toggle": "collapse",
        target: "header-tabs",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, { icon: "bars" })
        ], undefined, true),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_b_collapse, {
        "is-nav": "",
        id: "header-tabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_navbar_nav, { class: "ml-auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_nav_item, {
                to: "/",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createVNode(_component_font_awesome_icon, { icon: "home" }),
                    _hoisted_3
                  ])
                ], undefined, true),
                _: 1 /* STABLE */
              }),
              (_ctx.authenticated)
                ? (_openBlock(), _createBlock(_component_b_nav_item_dropdown, {
                    key: 0,
                    right: "",
                    id: "entity-menu",
                    "active-class": "active",
                    class: "pointer",
                    "data-cy": "entity"
                  }, {
                    "button-content": _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, [
                        _createVNode(_component_font_awesome_icon, { icon: "th-list" }),
                        _hoisted_5
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_entities_menu)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.hasAnyAuthority('ROLE_ADMIN') && _ctx.authenticated)
                ? (_openBlock(), _createBlock(_component_b_nav_item_dropdown, {
                    key: 1,
                    right: "",
                    id: "admin-menu",
                    class: _normalizeClass([{ 'router-link-active': _ctx.subIsActive('/admin') }, "pointer"]),
                    "active-class": "active",
                    "data-cy": "adminMenu"
                  }, {
                    "button-content": _withCtx(() => [
                      _createElementVNode("span", _hoisted_6, [
                        _createVNode(_component_font_awesome_icon, { icon: "users-cog" }),
                        _hoisted_7
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_b_dropdown_item, {
                        to: "/admin/user-management",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "users" }),
                          _hoisted_8
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_b_dropdown_item, {
                        to: "/admin/metrics",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "tachometer-alt" }),
                          _hoisted_9
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_b_dropdown_item, {
                        to: "/admin/health",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "heart" }),
                          _hoisted_10
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_b_dropdown_item, {
                        to: "/admin/configuration",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "cogs" }),
                          _hoisted_11
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_b_dropdown_item, {
                        to: "/admin/logs",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "tasks" }),
                          _hoisted_12
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      (_ctx.openAPIEnabled)
                        ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                            key: 0,
                            to: "/admin/docs",
                            "active-class": "active"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "book" }),
                              _hoisted_13
                            ], undefined, true),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["class"]))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_b_nav_item_dropdown, {
                right: "",
                href: "javascript:void(0);",
                id: "account-menu",
                class: _normalizeClass([{ 'router-link-active': _ctx.subIsActive('/account') }, "pointer"]),
                "active-class": "active",
                "data-cy": "accountMenu"
              }, {
                "button-content": _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_font_awesome_icon, { icon: "user" }),
                    _hoisted_15
                  ])
                ]),
                default: _withCtx(() => [
                  (_ctx.authenticated)
                    ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: 0,
                        "data-cy": "settings",
                        to: "/account/settings",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "wrench" }),
                          _hoisted_16
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (_ctx.authenticated)
                    ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: 1,
                        "data-cy": "passwordItem",
                        to: "/account/password",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "lock" }),
                          _hoisted_17
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (_ctx.authenticated)
                    ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: 2,
                        "data-cy": "logout",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout())),
                        id: "logout",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "sign-out-alt" }),
                          _hoisted_18
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.authenticated)
                    ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: 3,
                        "data-cy": "login",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLogin())),
                        id: "login",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "sign-in-alt" }),
                          _hoisted_19
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ], undefined, true),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["class"])
            ], undefined, true),
            _: 1 /* STABLE */
          })
        ], undefined, true),
        _: 1 /* STABLE */
      })
    ], undefined, true),
    _: 1 /* STABLE */
  }))
}